module.exports = __webpack_public_path__ + "static/media/hat-santa.788a9465.svg";